export default "__VITE_ASSET__C04vx59P__"